module.exports = __webpack_public_path__ + "img/9788954638272.c92cc908.jpg";